import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Tooltip, IconButton, Popover } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { getContent } from "../common/content";
const FormPopover = ({ rowId, children }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: getContent("openActionsMessage"), children: _jsx(IconButton, { onClick: handleClick, size: "small", children: _jsx(MoreHoriz, { fontSize: "inherit", color: "primary" }) }) }), _jsx(Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                }, children: children({ rowId, handleClose }) })] }));
};
export default FormPopover;
